import { render, staticRenderFns } from "./DemoButtonLoaders.vue?vue&type=template&id=2ae7ae4d&scoped=true&"
import script from "./DemoButtonLoaders.vue?vue&type=script&lang=js&"
export * from "./DemoButtonLoaders.vue?vue&type=script&lang=js&"
import style0 from "./DemoButtonLoaders.vue?vue&type=style&index=0&id=2ae7ae4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae7ae4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
